import { graphql } from 'react-apollo'
import { Layout, Form, Button, Input, notification, Divider, Table } from 'antd'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import searchBibQuery from '../graphql/queries/searchBib'

import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item

const getReference = (label) => {
  switch (label.app) {
    case 'shop': return label.referenceId
    case 'race': return label.data.bibs.join(', ')
    case 'inbox': return label.referenceId
    default: return '-'
  }
}

class searchBib extends Component {
  state = {
    submitting: false,
    labels: [],
  }
  loadLabels = async () => {
    this.setState({ submitting: true })
    const id = this.props.form.getFieldValue('id')
    try {
      if (id) {
        const { data: { labels } } = await this.props.labels.refetch({ bib: id })
        this.setState({ labels })
      }
    } catch (err) {
      notification.error({
        message: 'Error',
        description: err.message,
      })
    } finally {
      this.setState({ submitting: false })
    }
  }
  handleInputChange = (e) => {
    this.props.form.setFieldsValue({ [e.target.name]: e.target.value })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    const columns = [
      {
        title: 'Group',
        dataIndex: 'group',
        key: 'group',
        width: 150,
      },
      {
        title: 'Label ID',
        key: 'labelId',
        width: 100,
        className: 'text-center',
        render: record => (<span>{record._id}<br />({record.app})</span>),
      },
      {
        title: 'Reference',
        key: 'reference',
        width: 100,
        className: 'text-center',
        render: getReference,
      },
      {
        title: 'Recipient',
        dataIndex: 'recipient',
        key: 'recipient',
        width: 150,
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
      },
      {
        title: 'Count',
        key: 'count',
        width: 60,
        className: 'text-center',
        render: record => record.data.count,
      },
      {
        title: 'Items',
        key: 'item',
        width: 200,
        /* eslint react/no-array-index-key: 0 */
        render: record => (
          <ul style={{ paddingLeft: '20px' }}>
            {record.data.items && record.data.items.map(item => (
              <li key={`${record.referenceId} ${item.name}`}>[{item.amount}] {item.name}</li>
            ))}
            {record.data.shirts && record.data.shirts.map((shirt, index) => (
              <li key={`${record.referenceId} ${shirt} ${index}`}>{shirt}</li>
            ))}
          </ul>
        ),
      },
      {
        title: 'Tracking',
        key: 'tracking',
        width: 100,
        className: 'text-center',
        render: record => (record.tracking ? <span>[{record.tracking.carrier}]<br />{record.tracking.code}</span> : '-'),
      },
    ]
    return (
      <Layout>
        <Navbar selected="search:6" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <Form>
              <FormItem
                {...formItemLayout}
                label="Bib"
              >
                {getFieldDecorator('id', {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please input id!' }],
                })(
                  <Input type="text" name="Bib" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" style={{ marginRight: '10px' }} onClick={this.loadLabels} disabled={this.state.submitting}>Search</Button>
              </FormItem>
            </Form>
            <Divider />
            {this.state.labels.length > 0 ? (
              <div>
                <h2>Labels</h2>
                <Table
                  rowKey="_id"
                  dataSource={this.state.labels}
                  columns={columns}
                  pagination={{ pageSize: 50 }}
                  size="small"
                />
              </div>
            ) : null}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
searchBib.propTypes = {
  form: PropTypes.shape(),
}
searchBib.defaultProps = {
  form: {},
}

export default graphql(searchBibQuery, { name: 'labels', options: { variables: { bib: '' } } })(Form.create()(searchBib))



// WEBPACK FOOTER //
// ./src/pages/SearchBib.js